<div class="sales-order-line-items-assembly-order-dialog">
  <div class="lum-c-sales-order-line-items-transfer-order-dialog__header">
    <h2 mat-dialog-title>Assembly Order</h2>
  </div>

  <mat-select class="lum-select" [(ngModel)]="orderStatus">
    <mat-option [value]="eAssemblyOrderStatus.DRAFT">Draft</mat-option>
    <mat-option [value]="eAssemblyOrderStatus.COMPLETED">Completed</mat-option>
  </mat-select>

  <mat-dialog-actions align="end">
    <button class="lum-button lum-button--tertiary mr-2" mat-dialog-close>
      Cancel
    </button>
    <button class="lum-button" (click)="onSubmit()" cdkFocusInitial>
      Submit
    </button>
  </mat-dialog-actions>
</div>
